import { render, staticRenderFns } from "./QuizFinished.vue?vue&type=template&id=3e2c1b2e&scoped=true&"
import script from "./QuizFinished.vue?vue&type=script&lang=js&"
export * from "./QuizFinished.vue?vue&type=script&lang=js&"
import style0 from "./QuizFinished.vue?vue&type=style&index=0&id=3e2c1b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2c1b2e",
  null
  
)

export default component.exports